import React from 'react';
import { createUseStyles } from 'react-jss';
import cx from 'classnames';
import { ChevronDown, ChevronUp, ChevronRight, ChevronLeft } from './Icons';

type Props = {
  width?: number;
  size: 'small' | 'large';
  direction?: 'horizontal' | 'vertical';
  onClickLeft?: () => void;
  onClickRight?: () => void;
  disableLeft?: boolean;
  disableRight?: boolean;
};

const useStyles = createUseStyles({
  container: ({ direction }: Props) => ({
    display: 'flex',
    flexDirection: direction === 'horizontal' ? 'row' : 'column',
  }),
  button: ({ width = 24 }: Props) => ({
    flex: 1,
    width: width,
    border: 0,
    outline: 0,
    cursor: 'pointer',
    padding: 0,
    background: 'none',
    touchAction: 'manipulation',

    '& svg': {
      fill: '#000',
    },
    '&:hover svg': {
      fill: '#6d809c',
    },
  }),
  buttonLarge: {
    width: 32,
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
});

const ChevronToggle = (props: Props) => {
  const classes = useStyles(props);
  const {
    onClickLeft,
    onClickRight,
    size,
    direction = 'horizontal',
    disableLeft = false,
    disableRight = false,
  } = props;

  const buttonStyle = cx({
    [classes.button]: true,
    [classes.buttonLarge]: size === 'large',
  });
  const svgSize = size === 'large' ? 28 : 24;
  const isHorizontal = direction === 'horizontal';
  const LeftIcon = isHorizontal ? ChevronLeft : ChevronUp;
  const RightIcon = isHorizontal ? ChevronRight : ChevronDown;

  return (
    <div className={classes.container}>
      <button
        onClick={onClickLeft}
        className={cx(buttonStyle, { [classes.disabled]: disableLeft })}
        type="button"
      >
        <LeftIcon width={svgSize} height={svgSize} />
      </button>
      <button
        onClick={onClickRight}
        className={cx(buttonStyle, { [classes.disabled]: disableRight })}
        type="button"
      >
        <RightIcon width={svgSize} height={svgSize} />
      </button>
    </div>
  );
};

export default ChevronToggle;
